import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";

var Toggle = function Toggle(_ref) {
  var isInline = _ref.isInline,
      isExpanded = _ref.isExpanded,
      showLessLabel = _ref.showLessLabel,
      showMoreLabel = _ref.showMoreLabel,
      onToggle = _ref.onToggle;
  var getClassName = getClassNameFactory(Toggle.displayName);
  var chevronClassName = getClassName({
    descendantName: "icon",
    states: isExpanded ? "expanded" : "collapsed"
  });
  var containerClassName = getClassName({
    states: isExpanded ? "expanded" : "collapsed"
  });
  var labelText = isExpanded ? showLessLabel : showMoreLabel;
  return /*#__PURE__*/React.createElement("button", {
    "aria-expanded": isExpanded ? "true" : "false",
    className: containerClassName,
    onClick: onToggle,
    tabIndex: 0
  }, isInline && labelText, /*#__PURE__*/React.createElement("span", {
    className: chevronClassName
  }, /*#__PURE__*/React.createElement(ChevronDownIcon, {
    width: 24
  })), !isInline && labelText);
};

Toggle.displayName = "ShowMore.Toggle";
export default Toggle;